<oph-skip-dialog-content [message]="message" (close)="onClose($event)" [loading]="loading()"></oph-skip-dialog-content>
